import React, { useReducer } from 'react';
import { connect } from 'react-redux';
import { Button } from 'ui';
import ArchiveConfirmation from './ArchiveConfirmation';

const toggle = value => !value;

const Archive = ({ event, features, session }) => {
  const [showConfirmation, toggleConfirmation] = useReducer(toggle, false);
  return (
    <>
      {showConfirmation && (
        <ArchiveConfirmation onDismiss={toggleConfirmation} session={session} />
      )}
      <Button icon="archive" small fullWidth onClick={toggleConfirmation}>
        {t('common.archive')}
      </Button>
    </>
  );
};

const mapStateToProps = state => ({
  event: state.event,
});

export default connect(mapStateToProps)(Archive);
